import { useState } from "react";
import { ChevronDown } from "lucide-react";
import {
  Box,
  Button,
  Icon,
  Input,
  Menu,
  MenuButton,
  MenuDivider,
  MenuItem,
  MenuList,
} from "@chakra-ui/react";

interface BookOption {
  id: string;
  name: string;
}

export function BookFilter({
  books,
  value,
  onChange,
  allLabel,
  searchPlaceholder,
}: {
  books: BookOption[];
  value: string | null;
  onChange: (id: string | null) => void;
  allLabel: string;
  searchPlaceholder: string;
}) {
  const [filter, setFilter] = useState("");
  const shown = books.filter((b) =>
    (b.name || "").toLowerCase().includes(filter.toLowerCase()),
  );
  const selectedName = value
    ? books.find((b) => b.id === value)?.name || value
    : allLabel;

  return (
    <Menu isLazy>
      <MenuButton
        as={Button}
        size="sm"
        variant="outline"
        rightIcon={<Icon as={ChevronDown} boxSize={4} />}
        maxW="260px"
        fontWeight="normal"
      >
        <Box as="span" noOfLines={1}>
          {selectedName}
        </Box>
      </MenuButton>
      <MenuList maxH="340px" overflowY="auto" px={2} minW="260px">
        <Input
          size="sm"
          mb={2}
          placeholder={searchPlaceholder}
          value={filter}
          onChange={(e) => setFilter(e.target.value)}
        />
        <MenuItem onClick={() => onChange(null)} fontWeight={value ? "normal" : "semibold"}>
          {allLabel}
        </MenuItem>
        <MenuDivider />
        {shown.map((b) => (
          <MenuItem key={b.id} onClick={() => onChange(b.id)}>
            <Box as="span" noOfLines={1}>
              {b.name || "—"}
            </Box>
          </MenuItem>
        ))}
      </MenuList>
    </Menu>
  );
}
